import type {
    ComposableOptionsBase,
    Agreement,
    AgreementRequest
} from '~/types';
import { AgreementModel } from '~/models';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch, useGenericCrudMethods } from '~/composables';
import type { NitroFetchOptions } from 'nitropack';
import type { NuxtError } from '#app';


export interface UseAgreementsOptions extends ComposableOptionsBase {}
export function useAgreements(options: Partial<UseAgreementsOptions> = {}) {
    const apiBasePath = '/v1/agreements';
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch({ siteContext: options.siteContext });
    const genericCrudMethods = useGenericCrudMethods<Agreement>(apiBasePath, AgreementModel);

    async function signAgreement(
        uid: string,
        data: Partial<AgreementRequest>
    ): Promise<unknown | NuxtError> {
        const url = `${apiBasePath}/${uid}/sign/`;
        const config: NitroFetchOptions<string> = {
            body: data,
            method: 'POST'
        };

        try {
            return await $_fetch<AgreementRequest>(url, config);
        } catch (err) {
            return useApiUtilsObj.getNuxtErrorObj(err);
        }
    }

    return {
        ...genericCrudMethods,
        signAgreement
    };
}
